export default "__VITE_ASSET__BW0OJl0J__"